









































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { PolicyDto } from "@/api/ClientPortalApiClient";
import { Prop } from "vue-property-decorator";
import router, { ROUTES } from "@/router";
import { RoleStore } from "@/store";
import { FormatDate } from "@/filters/FormatDate";

@Component
export default class PolicyCardInvestment extends Vue {
  @Prop(PolicyDto) readonly policyDetails: PolicyDto | undefined;
  @Prop() perform: number | undefined;

  openPolicyDetails() {
    if (this.policyDetails) {
      router.push({
        name: ROUTES.policyDetailsInvestment,
        params: { policyId: this.policyDetails.id.toString() }
      });
    }
  }

  get IsExternalBroker(): boolean {
    return RoleStore.isExternalBroker || RoleStore.isBrokerClient;
  }
}
